import './bluefiretotal6/style';
import FormStructure from './bluefiretotal6/form_structure';

export default FormStructure;